import Assets from "./Assets";

export default class Sprites {

  static init(callback) {
    Sprites._prepareSheets(callback);
  }

  static getSpriteByRowCol(id, row, col) {
    let sheet = Sprites._getSheetById(id);
    if (sheet) {
      return sheet.sprites[row][col];
    }
    return null;
  }

  static getAllSprites(id) {
    let sheet = Sprites._getSheetById(id);
    let ret = new Array();
    if (sheet) {
      let a = sheet.sprites;
      for (let y = 0; y < a.length; y++) {
        for (let x = 0; x < a[y].length; x++) {
          ret.push(a[y][x])
        }
      }
    }
    return ret;
  }


  static _getSheetById(idSheet) {
    return Sprites._sheets.find(({ id }) => id === idSheet);
  }

  static _prepareSheets(callback) {
    if (Sprites._inited) {
      return
    }
    Sprites._inited = true;
    Sprites._sheets = Assets.getSpritesheets();
    Sprites._prepareNextSheet(callback);
  }

  static _prepareNextSheet(callback) {
    if (Sprites._current < Sprites._sheets.length) {
      Sprites._dispatch(callback, Sprites.EVENT_PREPARE_NEXT, { current: Sprites._current, total: Sprites._sheets.length });
      Sprites._prepare(callback);
    } else {
      Sprites._dispatch(callback, Sprites.EVENT_ALL_PREPARED, { current: Sprites._current, total: Sprites._sheets.length });
    }

  }

  static _prepare(callback) {
    let sheet = Sprites._sheets[Sprites._current];
    let image = sheet.asset;
    let w = sheet.asset.width;
    let h = sheet.asset.height;

    Sprites._canvas = jQuery("<canvas width='" + w + "px' height='" + h + "px'></canvas>");
    jQuery("body").append(Sprites._canvas);
    let ctx = Sprites._canvas.get(0).getContext("2d");
    ctx.drawImage(image, 0, 0);
    sheet.sprites = new Array();
    let rows = Math.floor(h / sheet.height);
    let cols = Math.floor(w / sheet.width);
    for (let row = 0; row < rows; row++) {
      sheet.sprites.push(new Array())
      for (let col = 0; col < cols; col++) {
        let imageUrl = Sprites.crop(ctx, row, col, sheet.width, sheet.height);
        sheet.sprites[sheet.sprites.length - 1].push(imageUrl);
      }
    }
    Sprites._canvas.remove();
    Sprites._current++;
    Sprites._dispatch(callback, Sprites.EVENT_SINGLE_PREPARED, { current: Sprites._current, total: Sprites._sheets.length });
    requestAnimationFrame(Sprites._prepareNextSheet.bind(Sprites, callback));
  }

  static crop(ctx, row, col, tileWidth, tileHeight) {
    let img = ctx.getImageData(col * tileWidth, row * tileHeight, tileWidth, tileHeight);
    let canvas = jQuery("<canvas width='" + tileWidth + "px' height='" + tileHeight + "px'></canvas>");
    jQuery("body").append(canvas);
    let ctxtile = canvas.get(0).getContext("2d");
    ctxtile.putImageData(img, 0, 0);
    let ret = canvas.get(0).toDataURL();
    canvas.remove();
    return ret;
  }


  static _dispatch(callback, type, data = null) {
    if (callback) {
      callback.call(null, { type: type, data: data });
    }
  }

}

Sprites._sheets = [];
Sprites._current = 0;
Sprites._inited = false;


Sprites.EVENT_PREPARE_NEXT = "eventPrepareNext";
Sprites.EVENT_ALL_PREPARED = "eventAllPrepared";
Sprites.EVENT_SINGLE_PREPARED = "eventSinglePrepared";
